import React from 'react';
import PropTypes from 'prop-types';

import { ExportsFormField } from './ExportsFormField';
import { FieldPropType } from '../propTypes';

export const ExportsFormSecondBlock = ({
  form,
  fieldNamePrefix,
  fields,
  disabled,
  formItemLayout,
  onChange,
}) => {
  return fields.map((field, index) => (
    <ExportsFormField
      key={`${field.id}_${field.queryParamNames.join(',')}_${field.type}`}
      form={form}
      fieldName={`${fieldNamePrefix}.${field.queryParamNames}`}
      fieldLabel={field.name}
      fieldType={field.type}
      multiple={Boolean(field.allowMultiSelect)}
      optionsUrl={field.callMethod}
      optionsItemMapping={field.callMethodFields}
      disabled={disabled}
      formItemLayout={formItemLayout}
      onChange={onChange}
    />
  ));
};

ExportsFormSecondBlock.propTypes = {
  form: PropTypes.object.isRequired,
  fieldNamePrefix: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(FieldPropType).isRequired,
  disabled: PropTypes.bool.isRequired,
  formItemLayout: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
